import React from 'react';
import ReactTooltip from 'react-tooltip';
const ErrorHint = ({ text, id, place }) => {

    return (
        text ?
        <>
            <ReactTooltip className='bg-danger' id={id} place={place} multiline={true}>
            </ReactTooltip>
            <i
                data-tip={text}
                data-for={id}
                className='fa fa-exclamation-circle text-danger ml-1'
                aria-hidden='true'
            ></i>
        </>
        :
        <div></div>
    );
};

export default ErrorHint;
